const ADD        = '/ajouter';
const ID_PATTERN = '/:id(\\d+)';

// racine
export const ROOT = '/';

export const RESET_PASSWORD_PATTERN = '/reinitialisation-mot-de-passe/:token([\\w\\-\\_]+)';

export const AIDE = '/aide';

export const REGIONS = '/Regions'

// glossaire

export const GLOSSAIRE = '/Glossaire'

// information reglementaire

export const INFORMATION_REGLEMENTAIRE = '/information-reglementaire'

// groupes d'utilisateurs
export const GROUPS = '/groupes';

// collectivités locales
export const LOCAL_AUTHORITIES        = '/collectivites';
export const LOCAL_AUTHORITIES_ADD    = LOCAL_AUTHORITIES + ADD;
export const LOCAL_AUTHORITIES_DETAIL = LOCAL_AUTHORITIES + ID_PATTERN;

// cabinets comptables
export const OFFICES        = '/cabinets';
export const OFFICES_ADD    = OFFICES + ADD;
export const OFFICES_DETAIL = OFFICES + ID_PATTERN;

// instructions
export const INSTRUCTIONS        = '/instructions';
export const INSTRUCTIONS_ADD    = INSTRUCTIONS + ADD;
export const INSTRUCTIONS_DETAIL = INSTRUCTIONS + ID_PATTERN;

// PPI
export const PPI        = '/ppi';
export const NewPPI     = "/new-ppi"
export const PPI_ADD    = PPI + ADD;
export const PPI_DETAIL = PPI + ID_PATTERN;

// utilisateurs
export const USERS        = '/utilisateurs';
export const USERS_ADD    = USERS + ADD;
export const USERS_DETAIL = USERS + ID_PATTERN;

// domain
export const LOCAL_AUTHORITY_PATTERN          = '/:slug(\\d+\\-[\\w\\-]+)';
export const BUDGETS_ANNEXES                  =  `${LOCAL_AUTHORITY_PATTERN}/budgetsannexes`
export const LOCAL_AUTHORITY_SERVICES_PATTERN = `${LOCAL_AUTHORITY_PATTERN}/services`;
export const LOCAL_AUTHORITY_SERVICE_PATTERN  = `${LOCAL_AUTHORITY_SERVICES_PATTERN}/:service_id(\\d+)`;
export const LOCAL_AUTHORITY_INSTRUCTION      = `${LOCAL_AUTHORITY_PATTERN}/instruction`;

// constat rétrospectif
export const RETROSPECTIVE             = '/constat-retrospectif';
export const RETROSPECTIVE_INVESTMENT  = RETROSPECTIVE + '/investissement';
export const RETROSPECTIVE_OPERATION   = RETROSPECTIVE + '/fonctionnement';
export const RETROSPECTIVE_RATIOS      = RETROSPECTIVE + '/ratios';
export const RETROSPECTIVE_SUMMARY     = RETROSPECTIVE + '/recapitulatif';
export const RETROSPECTIVE_TAX         = RETROSPECTIVE + '/fiscalite';
// constat rétrospectif - dette
export const RETROSPECTIVE_DEBT        = RETROSPECTIVE + '/dette';
export const RETROSPECTIVE_DEBT_ADD    = RETROSPECTIVE_DEBT + ADD;
export const RETROSPECTIVE_DEBT_DETAIL = RETROSPECTIVE_DEBT + ID_PATTERN;

// projection financière
export const PROJECTION                  = '/projection-financiere';
export const PROJECTION_SCENARII         = PROJECTION + '/scenarios-fonctionnement';
/** Modèle du chemin des scnéarios d'une collectivité */
export const PROJECTION_SCENARII_PATTERN = `${LOCAL_AUTHORITY_PATTERN}${PROJECTION_SCENARII}`
/** Modèle du chemin d'un d'une collectivité */
export const PROJECTION_SCENARIO_PATTERN = `${LOCAL_AUTHORITY_PATTERN}${PROJECTION_SCENARII}/:scenarioId(\\d+)`
export const PROJECTION_COUNTERS         = PROJECTION + '/compteurs';
//export const PROJECTION_PPI        = PROJECTION + '/ppi';

// suivi personnalisé
export const CUSTOM_TRACKING = "/suivi-personnalise"
export const CUSTOM_TRACKING_PATTERN = `${LOCAL_AUTHORITY_PATTERN}${CUSTOM_TRACKING}`
export const MANAGEMENT_REPORT_SEGMENT = "rapport-de-gestion"
export const CUSTOM_TRACKING_MANAGEMENT_REPORT = `${CUSTOM_TRACKING}/${MANAGEMENT_REPORT_SEGMENT}`
export const CUSTOM_TRACKING_MANAGEMENT_REPORT_PATTERN = `${CUSTOM_TRACKING_PATTERN}/${MANAGEMENT_REPORT_SEGMENT}`
export const POLICY_SEGMENT = "politique"
export const CUSTOM_TRACKING_POLICY = `${CUSTOM_TRACKING}/${POLICY_SEGMENT}`
export const CUSTOM_TRACKING_POLICY_PATTERN = `${CUSTOM_TRACKING_PATTERN}/${POLICY_SEGMENT}`

export const TDB = `${LOCAL_AUTHORITY_PATTERN}`
export const COLLECTIVITE = `${LOCAL_AUTHORITY_PATTERN}/details`

// connexion
export const LOGIN = TDB;




// WEBPACK FOOTER //
// ./src/util/routes.js